import { Injectable } from '@angular/core';
import { gql, Mutation } from 'apollo-angular';

export interface CreateSocketTicketResponse {
  createSocketTicket: {
    ticket: string;
    expiresAt: string;
  };
}

// Mints a single-use socket handshake ticket (60s TTL, consumed server-side on
// first use). Fetch just-in-time before each connect attempt — never cache one.
@Injectable({
  providedIn: 'root',
})
export class SocketTicketService extends Mutation<CreateSocketTicketResponse> {
  document = gql`
    mutation CreateSocketTicket {
      createSocketTicket {
        ticket
        expiresAt
      }
    }
  `;
}
